import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={68}
    height={33}
    viewBox={'0 0 68 33'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#fff'}
      d="M7.22 7.5H5.24v18.28h1.98V7.5ZM25.79 7.5h-1.98v18.28h1.98V7.5ZM30.43 9.852h-1.98v13.59h1.98V9.851ZM49 7.5h-1.98v18.28H49V7.5ZM53.64 9.852h-1.98v13.59h1.98V9.851ZM2.58 13.063H.6v7.17h1.98v-7.17ZM67.56 13.063h-1.98v7.17h1.98v-7.17ZM11.86 3.922H9.88v25.45h1.98V3.922ZM21.15 3.922h-1.98v25.45h1.98V3.922ZM16.5.96h-1.98v31.38h1.98V.96ZM35.07 3.922h-1.98v25.45h1.98V3.922ZM44.35 3.922h-1.98v25.45h1.98V3.922ZM62.92 7.5h-1.98v18.28h1.98V7.5ZM58.28 3.922H56.3v25.45h1.98V3.922ZM39.71.96h-1.98v31.38h1.98V.96Z"
    />
  </Svg>
);
export default SvgComponent;
